import { IColumnHeader } from '@aon/aon-tws-common-ui';
import * as React from 'react';
import { TooltipContentTitle, TooltipContentWrapper } from '../components/common';
import ContentConstants from '../contentConstants';
import { IColumn } from '../models';
import { ColumnHelper } from './ColumnHelper';

const getSurveyQuestionColumns = () => {
	return [
		addToSurveyColumn,
		questionIdColumn,
		dimensionColumn,
		questionTypeColumn,
		sourceTypeColumn,
		questionTextColumn,
		responseOptionColumn,
		questionTemplateColumn,
		altVersionsColumn,
		tagsColumn,
		allEnabledLanguagesColumn,
		allEnabledBenchmarksColumn,
	];
};

const getDemographicQuestionColumns = () => {
	return [
		addToSurveyColumn,
		questionIdColumn,
		questionTextColumn,
		responseOptionColumn,
		sourceTypeColumn,
		mappedAttributeColumn,
		altVersionsColumn,
		tagsColumn,
		allEnabledLanguagesColumn,
	];
};

const getColumnHeaders = (selectedColumns: IColumn[]): IColumnHeader[] => {
	const sortedColumns = [...selectedColumns].sort((a, b) => a.displayOrder - b.displayOrder);
	const columnHeaders = ColumnHelper.GetColumnHeaders(sortedColumns);
	columnHeaders.forEach((columnHeader: IColumnHeader) => {
		if (columnHeader.field === mappedAttributeColumn.name) {
			columnHeader.tooltipContent = (
				<TooltipContentWrapper>
					<TooltipContentTitle>{ContentConstants.MAPPED_ATTRIBUTE_TOOLTIP_TITLE}</TooltipContentTitle>
					<div>{ContentConstants.MAPPED_ATTRIBUTE_TOOLTIP_BODY}</div>
				</TooltipContentWrapper>
			);
		}
	});

	return columnHeaders;
};

export const LibraryQuestionColumnHelper = {
	getSurveyQuestionColumns,
	getDemographicQuestionColumns,
	getColumnHeaders,
};

const addToSurveyColumn: IColumn = {
	displayText: 'Add to Survey',
	name: 'isSelected',
	checked: true,
	displayOrder: 1,
	disabled: true,
	sortAscByDefault: true,
	isSortable: true,
};
const questionIdColumn: IColumn = {
	displayText: 'Question ID',
	name: 'code',
	checked: false,
	displayOrder: 2,
	sortAscByDefault: true,
	isSortable: true,
	disabled: false,
};
const questionTextColumn: IColumn = {
	displayText: 'Question',
	name: 'text',
	checked: true,
	displayOrder: 3,
	disabled: true,
	isSortable: true,
	sortAscByDefault: true,
};
const responseOptionColumn: IColumn = {
	displayText: 'Response Option',
	name: 'responseOptionGroup',
	checked: true,
	displayOrder: 4,
	disabled: true,
};
const dimensionColumn: IColumn = {
	displayText: 'Dimension',
	name: 'dimensions',
	checked: true,
	displayOrder: 5,
	sortAscByDefault: true,
	isSortable: true,
	disabled: false,
};
export const questionTypeColumn: IColumn = {
	displayText: 'Question Type',
	name: 'questionType',
	checked: false,
	displayOrder: 6,
	disabled: false,
};
export const sourceTypeColumn: IColumn = {
	displayText: 'Source',
	name: 'sourceType',
	checked: true,
	displayOrder: 7,
	disabled: true,
	isSortable: false,
};
const mappedAttributeColumn: IColumn = {
	displayText: 'Mapped Attribute',
	name: 'mappedAttribute',
	checked: true,
	displayOrder: 8,
	disabled: false,
};
const questionTemplateColumn: IColumn = {
	displayText: 'Question Template',
	name: 'questionTemplates',
	checked: false,
	displayOrder: 9,
	disabled: false,
};
const altVersionsColumn: IColumn = {
	displayText: 'Alt Versions',
	name: 'alternateVersions',
	checked: true,
	displayOrder: 10,
	disabled: false,
};
const tagsColumn: IColumn = {
	displayText: 'Tags',
	name: 'tags',
	checked: false,
	displayOrder: 11,
	disabled: false,
};
const allEnabledLanguagesColumn: IColumn = {
	displayText: 'All Enabled Languages',
	name: 'allChosenLanguages',
	checked: true,
	displayOrder: 12,
	disabled: false,
	sortAscByDefault: false,
};
const allEnabledBenchmarksColumn: IColumn = {
	displayText: 'All Enabled Benchmarks',
	name: 'allChosenBenchmarks',
	checked: false,
	displayOrder: 14,
	disabled: false,
	sortAscByDefault: false,
};
